export default __webpack_public_path__ + "static/media/lista-participantes.34245727.png";